

export default {
    google: function () {
        return "AIzaSyCqYJCfhuzDRI4b49rtUHSr6QNdxOvRihc"
    },
    wash: function () {
        return 'ce8eaa09-17ad-46c4-b626-97eaa3a2199d'
    }
}
    


